import React from 'react';
import { Col, Container, Row } from 'reactstrap';

import smartDietPlanImg from '../../../assets/images/DietPlans/diet-plan-feature/smart-diet-plan.svg';
import unlockContentImg from '../../../assets/images/DietPlans/diet-plan-feature/unlock-exclusive-content.svg';
import reportInsightImg from '../../../assets/images/DietPlans/diet-plan-feature/report-for-insights.svg';

const featureArray = [{
    title: "Smart diet plan",
    description: "We base our diet plans on your preferences and goals with limited options",
    icon: smartDietPlanImg
}, {
    title: "Unlock exclusive content",
    description: "Get access to fitness videos, articles and wellness section in the app.",
    icon: unlockContentImg
}, {
    title: "Report for insights",
    description: "Get nutrition report with macro nutrient analysis based on your food log. ",
    icon: reportInsightImg
}];

const FreeFeature = () => {

    const Items = ({item}) => (
        <Row>
            <Col xs="2" className='text-end'><img src={item.icon} alt="" className='feature-icon-img' /></Col>
            <Col xs="10" className='ps-2'>
                <h4 className='feature-title mb-1'>{item.title}</h4>
                <p className='feature-description'>{item.description}</p>
            </Col>
        </Row>
    );
    
    return(
        <Container className='pt-0'>
            <h3 className='diet-plan-free-title mt-4 pt-2 mb-4'>Quick start your journey <br/>to <span className='yellow'>better health</span></h3>
            {
                featureArray.map((item, i) => <Items item={item} key={item.title} />)
            }
        </Container>
    );
}

export default FreeFeature;